import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { OpenableElementsQuery } from '../../queries/openable_elements_query';

export class StudentFeedbackDialogController {
  constructor(
    private ngOpenableElementsQuery: OpenableElementsQuery,
    private closeOpenableElementCommand: ICommand,
    private submitStudentFeedbackCommand: ICommand,
    private $element: ng.IAugmentedJQuery
  ) {}
  closeStudentFeedback() {
    return this.closeOpenableElementCommand('studentFeedbackDialog');
  }

  clearAndCloseDialog() {
    (this.$element[0].querySelector<HTMLFormElement>('#student-feedback-form') as unknown as HTMLFormElement)[
      'reset'
    ]();
    this.closeStudentFeedback();
  }

  onStudentFeedbackFormSubmitted($event: any) {
    const studentFeedbackFormData: any = _4.get($event, 'detail.value', {});
    this.submitStudentFeedbackCommand(studentFeedbackFormData).then(() => {
      this.clearAndCloseDialog();
    });
  }
}
export class StudentFeedbackDialogComponent implements ng.IComponentOptions {
  public controller: object = StudentFeedbackDialogController;
  public templateUrl: string =
    'capability-ng-priority-feed/src/components/student_feedback_dialog/student_feedback_dialog.html';
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/student_feedback_dialog/student_feedback_dialog.ts